export default __webpack_public_path__ + "media/images/temps-new-6ee6fde04b59216b6c3936e83411ed28.png";